
// SVG Icon: upload
export default { id: "terriajs-upload" };
export const id = "terriajs-upload";
export const name = "upload";
